var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#DE9636"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_762_849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5771 36.4518L24.2644 42.6389L13.4855 36.4395C12.251 35.7302 11.4902 34.4148 11.4902 32.9913V10.2726L24.397 8.49084L36.5085 10.2726V33.0404C36.5085 34.4369 35.7747 35.7327 34.5771 36.4518Z",
    stroke: "white",
    strokeWidth: 0.981688,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4962 22.0455H26.5387V17.0855H21.4634V22.0455H16.5059V27.1184H21.4634V32.0784H26.5387V27.1184H31.4962V22.0455Z",
    stroke: "white",
    strokeWidth: 0.981688,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_762_849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 35.1297,
    fill: "white",
    transform: "translate(11 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDi);
export default __webpack_public_path__ + "static/media/DI.a784e386fe5d27861cd2d46adf5a7a81.svg";
export { ForwardRef as ReactComponent };